import React, { useContext } from 'react'
import { Link } from 'gatsby'
import { LayoutContext } from '../../contexts'

export const SiteLink = (props) => {
  const { node_locale } = useContext(LayoutContext)
  const { children, to, extension } = props
  return (
    <Link
      {...props}
      to={
        to === '/'
          ? `/${node_locale}/`
          : `/${node_locale}${to ? '/' + to : ''}/${
              extension ? extension + '/' : ''
            }`
      }
    >
      {children}
    </Link>
  )
}
